import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const faqs = [
  { q: 'Comment fonctionne la livraison ?', a: 'Nous délivrons vos abonnés, likes ou vues de manière progressive et naturelle pour respecter les algorithmes. La majorité des commandes sont livrées en 12h.' },
  { q: 'Faut-il donner mon mot de passe ?', a: 'Non, jamais. Nous n\'avons besoin que du lien public de votre compte ou de votre publication. Votre compte reste 100% sécurisé.' },
  { q: 'Puis-je être bannie ou pénalisée ?', a: 'Notre méthode respecte les conditions des réseaux sociaux. Depuis 2021, nous n\'avons enregistré aucun bannissement lié à nos services.' },
  { q: 'Les abonnés sont-ils réels ?', a: 'Nos abonnés de haute qualité proviennent de vrais comptes actifs. Vous pouvez choisir entre plusieurs qualités selon vos besoins.' },
  { q: 'Quels moyens de paiement acceptez-vous ?', a: 'Carte bancaire, Apple Pay, Google Pay, PayPal et crypto. Toutes les transactions sont chiffrées via Shopify Payments.' },
  { q: 'Puis-je obtenir un remboursement ?', a: 'Oui, nous offrons une garantie satisfait ou remboursement avec jusqu’à 2 renvois gratuits en cas de problème.' }
];

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-14">
          <div className="text-[#ff8247] text-xs font-bold uppercase tracking-widest mb-3">Questions fréquentes</div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
            Tout ce que vous devez <span className="gradient-text">savoir</span>.
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => (
            <div key={i} className={`glass-card rounded-2xl overflow-hidden transition ${open === i ? 'border-[#ff8247]/40' : ''}`}>
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between p-6 text-left">
                <span className="text-white font-semibold text-base md:text-lg pr-4">{f.q}</span>
                <div className={`w-9 h-9 rounded-full flex items-center justify-center transition ${open === i ? 'bg-[#ff8247] text-[#0a0a0f]' : 'bg-white/5 text-white'}`}>
                  {open === i ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                </div>
              </button>
              {open === i && (
                <div className="px-6 pb-6 text-white/60 leading-relaxed text-sm md:text-base">
                  {f.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
